import { Button, Stack } from '@mui/material';
import UploadFileButton from '../../../../common-components/upload-file/upload-file';

interface CsvCreateVesselsButtonGroupProps {
  onSubmit: () => void;
  onCancel: () => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  clearRef: boolean;
  submitButtonLabel?: string;
  submitDisabled?: boolean;
  cancelDisabled?: boolean;
}

function CsvCreateVesselsButtonGroup({
  onSubmit,
  onCancel,
  onChange,
  clearRef,
  submitButtonLabel,
  submitDisabled,
  cancelDisabled,
}: CsvCreateVesselsButtonGroupProps) {
  return (
    <Stack
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'stretch',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 1,
        width: '100%',
      }}
      data-testid="csv-create-vessels-group"
    >
      <Button
        onClick={onCancel}
        sx={{
          flex: 1,
          minWidth: '30%',
          whiteSpace: 'nowrap',
        }}
        variant="outlined"
        disabled={cancelDisabled}
        data-testid="csv-create-group-cancel-button"
      >
        Clear Upload
      </Button>
      <UploadFileButton
        label="Browse"
        onChange={onChange}
        acceptedFileTypes=".csv"
        clearRef={clearRef}
        sx={{
          flex: 1,
          minWidth: '30%',
          whiteSpace: 'nowrap',
        }}
      />

      <Button
        onClick={onSubmit}
        disabled={submitDisabled}
        sx={{
          flexGrow: 1,
          minWidth: '45%',
        }}
        data-testid="csv-group-submit-button"
      >
        {submitButtonLabel}
      </Button>
    </Stack>
  );
}

export default CsvCreateVesselsButtonGroup;

CsvCreateVesselsButtonGroup.defaultProps = {
  submitButtonLabel: 'Submit',
  submitDisabled: false,
  cancelDisabled: false,
};
